export const styles = {
	openAnswerContainer: {
		paddingTop: '12px',
		'& .MuiOutlinedInput-root': {
			borderRadius: '2px',
			'&:hover fieldset': {
				borderColor: '#4657F4',
			},
			'&.Mui-focused fieldset': {
				borderColor: '#4657F4',
				borderWidth: '1px',
			},
			'& fieldset': {
				borderColor: '#CAD7FF',
			},
		},
	},
};
